import { apiSaveStep, API_STEPS } from "../api/apiSaveStep";
import { ERROR_TEXTS } from "../utils/constants";
import { PERSONAL_DATA_FORM_FIELDS_NAMES } from "./personalDataForm";
import { apiGenerateOtp } from "../api/apiGenerateOtp";
import { offerCouponInvalid } from './offer';

export const RECAP_REDUCER_FIELD_NAMES = {
    isSubmittingForm: 'isSubmittingForm',
    submittingFormError: 'submittingFormError',
    successText: 'successText',
    timeStart: 'timeStart',
    timeSpent: 'tempoImpiegato'
}

const defaultState = {
    [RECAP_REDUCER_FIELD_NAMES.isSubmittingForm]: false,
    [RECAP_REDUCER_FIELD_NAMES.submittingFormError]: '',
    [RECAP_REDUCER_FIELD_NAMES.successText]: '',
    [RECAP_REDUCER_FIELD_NAMES.timeSpent]: 0,
    [RECAP_REDUCER_FIELD_NAMES.timeStart]: null,
}

export const RECAP_REDUCER_CHANGE_FIELD = 'RECAP_REDUCER_CHANGE_FIELD';
export const recapReducerChangeField = (name, value) => ({ type: RECAP_REDUCER_CHANGE_FIELD, name, value });

export const RECAP_REDUCER_RESET = 'RECAP_REDUCER_RESET';
const recapReducerReset = () => ({ type: RECAP_REDUCER_RESET })

export function recapReducerSubmit(isFinished = true) {
    return async (dispatch, getState) => {
        const { recapReducer: form, globalFormFieldsReducer } = getState();
        const otp = globalFormFieldsReducer.otp;

        dispatch(recapReducerReset());

        const timeSpent = form[RECAP_REDUCER_FIELD_NAMES.timeSpent]
            + parseInt(Date.now() / 1000, 10) - form[RECAP_REDUCER_FIELD_NAMES.timeStart];

        dispatch(recapReducerChangeField(RECAP_REDUCER_FIELD_NAMES.timeSpent, timeSpent));
        dispatch(recapReducerChangeField(RECAP_REDUCER_FIELD_NAMES.timeStart, parseInt(Date.now() / 1000, 10)));

        dispatch(recapReducerChangeField(RECAP_REDUCER_FIELD_NAMES.isSubmittingForm, true));

        try {
            await apiSaveStep(API_STEPS.fifth, {
                finished: isFinished,
                otp,
                [RECAP_REDUCER_FIELD_NAMES.timeSpent]: timeSpent
            });
            if (!isFinished) {
                dispatch(recapReducerChangeField(RECAP_REDUCER_FIELD_NAMES.successText, ERROR_TEXTS.saveSuccess));
                await apiGenerateOtp(otp);
            }
        } catch (error) {
            if (error.response.status === 400) {
                dispatch(offerCouponInvalid());
                throw "Coupon already used";
            } else {
                dispatch(recapReducerChangeField(RECAP_REDUCER_FIELD_NAMES.isSubmittingForm, ERROR_TEXTS.serverError));
                throw "Error saving data";
            }
        } finally {
            dispatch(recapReducerChangeField(RECAP_REDUCER_FIELD_NAMES.isSubmittingForm, false));
        }
    }
}

export function recapReducer(state = defaultState, action) {
    switch (action.type) {
        case RECAP_REDUCER_CHANGE_FIELD: {
            return { ...state, [action.name]: action.value }
        }
        case RECAP_REDUCER_RESET: {
            return {
                [RECAP_REDUCER_FIELD_NAMES.isSubmittingForm]: false,
                [RECAP_REDUCER_FIELD_NAMES.submittingFormError]: '',
                [RECAP_REDUCER_FIELD_NAMES.successText]: '',
            }
        }
        default: {
            return state;
        }
    }
}